import { constants } from "@newsela/angelou";

const { ui } = constants.colors;
const neutral400 = ui.neutral[400];
const neutral600 = ui.neutral[600];
const greyExtraLight50 = ui.neutral[25];

export const menuStyles = {
  display: "flex",
  flexFlow: "row wrap",
  alignItems: "center",
  flexGrow: 1,
  gap: "4px",
  padding: "4px",
  color: neutral600,
  backgroundColor: greyExtraLight50,
  border: `1px solid ${neutral400}`,
  borderCollapse: "collapse",
  borderBottomWidth: 0,
  borderRadius: "4px",
  borderBottomLeftRadius: 0,
  borderBottomRightRadius: 0,
};
